$shm_hitalama_map_widget_float_form $shm_hitalama_map_widget_float
	controls /
		<= Form $shm_hitalama_map_widget_entity_form_view
			form <= form $shm_hitalama_map_widget_entity_form
			map <= map
